export default {
  GROWL: "Pop-Over Display",
  NOTIFICATION_CENTER: "Notification Center Only",
  BANNER: "Banner Display",
};
